import { ExportTimeoutError, normalizeExportError } from "./errors";
import { runWithRetry as runPlatformRetry } from "../retry/executor";

export async function runWithRetry(operation, options) {
  const context = options.context ?? {};
  const exportId = context.exportId;

  return runPlatformRetry(operation, {
    ...options,
    operationId: exportId,
    context: {
      domain: "export",
      toolId: context.toolId,
    },
    createTimeoutError: (phase, id) => new ExportTimeoutError(phase, id),
    normalizeError: (error, phase, id, attempt) =>
      normalizeExportError(error, phase, id, attempt),
  });
}

export { runWithRetry as runPlatformWithRetry } from "../retry/executor";
